import {parcelVue as crmUsersApp} from "../EnswitchApps/crm/parcel";
import {parcelVue as dynamicRoutes} from "../EnswitchApps/dynamic-routes/parcel";
import {parcelVue as dynamicRoutesCustomers} from "../EnswitchApps/dynamic-routes-customers/parcel";
import {parcelVue as externalIntegrations} from "../EnswitchApps/external-integrations/parcel";
import {parcelVue as incomingsms} from "../EnswitchApps/incomingsms/parcel";
import {parcelVue as incomingsmscdr} from "../EnswitchApps/incomingsmscdr/parcel";
import {parcelVue as parcelCallcenterAgents} from "../EnswitchApps/callcenter-agents/parcel";
import {parcelVue as parcelCustomerTokens} from "../EnswitchApps/customer-tokens/parcel";
import {parcelVue as parcelCustomUrls} from "../EnswitchApps/custom-urls/parcel-custom-urls";
import {parcelVue as parcelCustomUrlsWebhook} from "../EnswitchApps/custom-urls/parcel-custom-urls-webhook";
import {parcelVue as parcelMailToFax} from "../EnswitchApps/mailtofax/parcel";
// import {parcelVue as payment} from "../EnswitchApps/payment/parcel";
import {parcelVue as randomCli} from "../EnswitchApps/random-cli/parcel";
import {parcelVue as whitelists} from "../EnswitchApps/whitelists/parcel";

class ParcelManager {
	register(name, obj) {
		if (this.items[name]) {
			throw new Error(`parcel '${name}' already registered`);
		}
		this.items[name] = obj;
	}
	getParcel(mountFunc, name, element, props) {
		let parcel = this.items[name];
		if (!parcel) {
			throw new Error(`parcel '${name}' is not valid`);
		}
		let outputParcel = parcel.generateParcel ? parcel.generateParcel() : parcel;
		return mountFunc(outputParcel, {domElement: element[0], ...props});
	}
	items = [];
}

export function getParcel(mountFunc, name, element, props) {
	return ParcelManagerInstance.getParcel(mountFunc, name, element, props);
}

const ParcelManagerInstance = new ParcelManager();

ParcelManagerInstance.register("crmusers", crmUsersApp);
ParcelManagerInstance.register("callcenterAgents", parcelCallcenterAgents);
ParcelManagerInstance.register("customUrls", parcelCustomUrls);
ParcelManagerInstance.register("customUrlsWebhook", parcelCustomUrlsWebhook);
ParcelManagerInstance.register("customerTokens", parcelCustomerTokens);
ParcelManagerInstance.register("mailToFax", parcelMailToFax);
ParcelManagerInstance.register("dynamicRoutes", dynamicRoutes);
ParcelManagerInstance.register("dynamicRoutesCustomers", dynamicRoutesCustomers);
ParcelManagerInstance.register("randomCli", randomCli);
ParcelManagerInstance.register("whitelists", whitelists);
ParcelManagerInstance.register("incomingsms", incomingsms);
ParcelManagerInstance.register("incomingsmscdr", incomingsmscdr);
// ParcelManagerInstance.register("payment", payment);
ParcelManagerInstance.register("external-integrations", externalIntegrations);
